import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import userstore from "./UserStore/userstore";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import registrationStore from "./RegistrationStore";
import clientStore from "./ClientStore";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { checklistStoreAPI } from "./checklistStoreAPI";
import checklistStore from "./checklistStoreAPI/checklistStore";

export const store = configureStore({
  reducer: {
    userstore,
    checklistStore,
    registrationStore,
    clientStore,
    [checklistStoreAPI.reducerPath]: checklistStoreAPI.reducer,
  },
  middleware: (getMiddlewares) => {
    let middlewares = getMiddlewares().concat([checklistStoreAPI.middleware]);

    return middlewares;
  },
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const useAppDispatch = () => {
  return useDispatch<AppDispatch>();
};

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
